import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useContext, useMemo } from 'react';
import OverridesContext from "./OverridesContext.js";

// #### /filters
import ToggleFilter from "../filters/ToggleFilter/styles.module.css.js";
import SelectFilter from "../filters/SelectFilter/styles.module.css.js";
import CheckboxFilter from "../filters/CheckboxFilter/styles.module.css.js";
import GeoRadiusFilter from "../filters/GeoRadiusFilter/styles.module.css.js";
import MultiSelectFilter from "../filters/MultiSelectFilter/styles.module.css.js";
import FuzzySearchFilter from "../filters/FuzzySearchFilter/styles.module.css.js";
// #### /layouts
import FilterField from "../layouts/FilterField/styles.module.css.js";
import FilterFieldset from "../layouts/FilterFieldset/styles.module.css.js";
import InlineControlGroup from "../layouts/InlineControlGroup/styles.module.css.js";
import TwoColumnStaticMapLayout from "../layouts/TwoColumnStaticMapLayout/styles.module.css.js";
import TwoColumnOverlayMapLayout from "../layouts/TwoColumnOverlayMapLayout/styles.module.css.js";
import OverlayHeader from "../layouts/TwoColumnOverlayMapLayout/OverlayHeader/styles.module.css.js";
import OverlayHeaderText from "../layouts/TwoColumnOverlayMapLayout/OverlayHeaderText/styles.module.css.js";
import OverlayToggleButton from "../layouts/TwoColumnOverlayMapLayout/OverlayToggleButton/styles.module.css.js";
// #### /controls
import Button from "../controls/Button/styles.module.css.js";
import Select from "../controls/Select/styles.module.css.js";
import TextInput from "../controls/TextInput/styles.module.css.js";
import RadioInput from "../controls/RadioInput/styles.module.css.js";
import CheckboxInput from "../controls/CheckboxInput/styles.module.css.js";
// #### /results
import NoResults from "../results/NoResults/styles.module.css.js";
import ResultsList from "../results/ResultsList/styles.module.css.js";
import GroupHeader from "../results/GroupHeader/styles.module.css.js";
import ResultGroup from "../results/ResultGroup/styles.module.css.js";
import SortIndicator from "../results/SortIndicator/styles.module.css.js";
import GroupedResultsList from "../results/GroupedResultsList/styles.module.css.js";
// #### /GoogleMaps
import GoogleMaps from "../GoogleMaps/styles.module.css.js";
import Popover from "../GoogleMaps/Popover/styles.module.css.js";
import PopoverHeading from "../GoogleMaps/Popover/PopoverHeading/styles.module.css.js";
import PopoverContent from "../GoogleMaps/Popover/PopoverContent/styles.module.css.js";
import PopoverCloseButton from "../GoogleMaps/Popover/PopoverCloseButton/styles.module.css.js";
export var StyleOverrideMap = {
  'filters/ToggleFilter': ToggleFilter,
  'filters/SelectFilter': SelectFilter,
  'filters/GeoRadiusFilter': GeoRadiusFilter,
  'filters/CheckboxFilter': CheckboxFilter,
  'filters/MultiSelectFilter': MultiSelectFilter,
  'filters/FuzzySearchFilter': FuzzySearchFilter,
  'layouts/FilterField': FilterField,
  'layouts/FilterFieldset': FilterFieldset,
  'layouts/InlineControlGroup': InlineControlGroup,
  'layouts/TwoColumnStaticMap': TwoColumnStaticMapLayout,
  'layouts/TwoColumnOverlayMap': TwoColumnOverlayMapLayout,
  'layouts/TwoColumnOverlayMap/OverlayHeader': OverlayHeader,
  'layouts/TwoColumnOverlayMap/OverlayHeaderText': OverlayHeaderText,
  'layouts/TwoColumnOverlayMap/OverlayToggleButton': OverlayToggleButton,
  'controls/Button': Button,
  'controls/Select': Select,
  'controls/TextInput': TextInput,
  'controls/RadioInput': RadioInput,
  'controls/CheckboxInput': CheckboxInput,
  'results/NoResults': NoResults,
  'results/ResultsList': ResultsList,
  'results/GroupHeader': GroupHeader,
  'results/ResultGroup': ResultGroup,
  'results/SortIndicator': SortIndicator,
  'results/GroupedResultsList': GroupedResultsList,
  'GoogleMaps': GoogleMaps,
  'GoogleMaps/Popover': Popover,
  'GoogleMaps/Popover/PopoverContent': PopoverContent,
  'GoogleMaps/Popover/PopoverCloseButton': PopoverCloseButton,
  'GoogleMaps/Popover/PopoverHeading': PopoverHeading
};
export var useStyleOverride = (componentName, baseStyle) => {
  var ctx = useContext(OverridesContext);
  var styles = useMemo(() => {
    if (typeof ctx.styles === 'function') {
      return _objectSpread(_objectSpread({}, baseStyle), ctx.styles(componentName, baseStyle));
    } else {
      if (componentName in ctx.styles && ctx.styles[componentName]) {
        var override = ctx.styles[componentName];
        if (typeof override === 'function') {
          return _objectSpread(_objectSpread({}, baseStyle), override(baseStyle));
        } else {
          return _objectSpread(_objectSpread({}, baseStyle), override);
        }
      } else {
        return baseStyle;
      }
    }
  }, [componentName, ctx.styles]);
  return styles;
};
export default useStyleOverride;
//# sourceMappingURL=useStyleOverride.js.map